import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import SelectCountryListByLocation from '../../features/utils/SelectCountryListByLocation';
import { cleanObjectData } from '../../features/utils/Utils';
// import { useInterviewHiringReportChartMutation } from '../../features/dashboard/dashboardApiSlice';
import { useOfferDroppedOutReportChartMutation } from '../../features/dashboard/dashboardApiSlice';

const OfferDroppedOutReportChart = () => {
  const [selectedCountryId, setSelectedCountryId] = useState(0);
  const [selectedLocationId, setSelectedLocationId] = useState(0);
  const [selectedBranchId, setSelectedBranchId] = useState(0);

  const [currentPage, setCurrentPage] = useState(1); // Current page
  const itemsPerPage = 5; // Items per page

  const [
    offerDroppedOutReportChart,
    { data: offerDroppedOutReportData, isLoading: interviewLoading },
  ] = useOfferDroppedOutReportChartMutation();

  useEffect(() => {
    callAPI();
  }, []);

  useEffect(() => {
    callAPI();
  }, [selectedCountryId, selectedLocationId, selectedBranchId]);

  const callAPI = () => {
    const data = {
      country_id: parseInt(selectedCountryId),
      location_id: parseInt(selectedLocationId),
      branch_id: parseInt(selectedBranchId),
    };
    const dataObj = cleanObjectData(data);
    offerDroppedOutReportChart(dataObj);
  };

  const chartData = offerDroppedOutReportData?.data || [];
  console.log('chartData',chartData);
  const chartName = 'Offer Dropped Out Report';

  const series = ['Accepted', 'Declined'];

  // Pagination logic: Slice the chart data based on the current page
  const getPaginatedData = (data) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  };

  const paginatedData = getPaginatedData(chartData);

  // Calculate the total number of pages
  const totalPages = Math.ceil(chartData.length / itemsPerPage);

    // Automatically go to the first page if the data has fewer pages than the current page
    useEffect(() => {
        if (currentPage > totalPages) {
          setCurrentPage(1); // Reset to the first page
        }
      }, [totalPages, currentPage]);

  // Get series data based on the paginated data
  const getSeriesData = () => {
    return series.map((seriesName, index) => {
      if (index === 0) {
        return {
          name: seriesName,
          data: paginatedData.map((item) => item[`Accepted`] || 0),
        };
      }
      if (index === 1) {
        return {
          name: seriesName,
          data: paginatedData.map((item) => item[`Declined`] || 0),
        };
      }
    });
  };

  const options = {
    chart: {
      type: 'bar',
      height: 380,
      fontFamily: 'Inter var',
      foreColor: '#000000',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          enabled: true,
          position: 'center',
        },
        barHeight: '15px',
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '10px',
        colors: ['#fff'],
      },
    },
    stroke: {
      show: false,
      width: 1,
      colors: ['#fff'],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    xaxis: {
      categories: paginatedData.map((item) => item.title),
      labels: {
        show: false,
      },
      axisBorder: {
        show: true,
        color: '#9ca3af',
        height: 1,
      },
    },
    yaxis: {
      axisBorder: {
        show: true,
        color: '#9ca3af',
        width: 1,
      },
    },
    grid: {
      show: true,
      borderColor: '#f3f4f6',
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    colors: ['#5EEE6E', '#F92D51'],
  };

  const setCountryId = (id) => {
    setSelectedCountryId(id);
  };

  const setLocationId = (id) => {
    setSelectedLocationId(id);
  };

  const setBranchId = (id) => {
    setSelectedBranchId(id);
  };

  // Handle page click
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons with numbers
  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={`px-2 mx-1 rounded ${currentPage === i ? 'bg-green-500 text-white' : 'bg-gray-200 text-black hover:bg-green-500 hover:text-white'}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }
    return pageNumbers;
  };

  return (
    <div>
      <div className="flex justify-between p-3">
        <div>
          <h1 className="text-black text-[16px] font-sans">{chartName}</h1>
        </div>
        <div>
          <SelectCountryListByLocation
            setCountryId={setCountryId}
            setLocationId={setLocationId}
            setBranchId={setBranchId}
            isDaysFilter={false}
            showCountry={true}
            showBranch={true}
            showLocation={true}
          />
        </div>
      </div>

      {/* Chart */}
      <ReactApexChart
        options={options}
        series={getSeriesData()}
        type="bar"
        height={380}
        width={567}
      />

      {/* Pagination Buttons */}
      <div className="flex justify-center">
        {renderPageNumbers()}
      </div>

      {/* Page Indicator */}
      {/* <div className="text-center mt-2">
        Page {currentPage} of {totalPages}
      </div> */}
    </div>
  );
};

export default OfferDroppedOutReportChart;